import { serviceApi } from '~/features';
import { DeleteResponse } from '~/types/cnpj/delete.response';

export async function deleteCnjpsList(campanhaId: string) {
  return serviceApi.delete<DeleteResponse>(
    `/Campanha/DeleteCNPJ?campanhaId=${campanhaId}`
  );
}
